import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import HomeHeroSection from '../components/home/HomeHeroSection';
import ElfsightWidget from '../components/about/ElfsightWidget';
import SEOHead from '../components/SEOHead';

const Index = () => {
  const homeJsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "ParadoxEdge",
      "description": "Executive coaching practice for the human side of AI transformation. Develops the human capacity (judgment, presence, trustworthiness) that determines whether AI investment lands.",
      "url": "https://www.paradoxedge.com",
      "logo": "https://www.paradoxedge.com/lovable-uploads/180210a9-9a73-4038-a36b-f373598ef48a.png",
      "image": "https://www.paradoxedge.com/og-image.png?v=3",
      "priceRange": "$$$$",
      "serviceType": ["Executive Coaching for AI Transformation", "The Human Side of AI", "Executive Coaching", "Leadership Development", "Organizational Development"],
      "areaServed": "Worldwide",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Denver",
        "addressRegion": "CO",
        "addressCountry": "US"
      },
      "founder": {
        "@type": "Person",
        "name": "Kent Frazier",
        "jobTitle": "Founder & CEO",
        "url": "https://www.linkedin.com/in/kent-frazier/"
      },
      "sameAs": [
        "https://www.linkedin.com/company/90481320",
        "https://www.linkedin.com/in/kent-frazier/"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "ParadoxEdge",
      "url": "https://www.paradoxedge.com",
      "inLanguage": "en-US",
      "publisher": { "@type": "Organization", "name": "ParadoxEdge" }
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is ParadoxEdge?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "ParadoxEdge is an executive coaching practice for the human side of AI transformation. Founded by Kent H. Frazier, it partners with leaders and companies deploying AI to develop the human capacity (judgment, presence, and trustworthiness) that determines whether AI investment actually lands."
          }
        },
        {
          "@type": "Question",
          "name": "What is 'human capacity' in an AI transformation?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Human capacity is the ability of leaders and teams to hold judgment, discernment, and accountability at the pace AI now moves. Capital is flooding the technical layer of AI, but human capacity is the scarce resource that is not getting investment. It is the asset that does not commoditize, and the leverage point of the AI transformation."
          }
        },
        {
          "@type": "Question",
          "name": "Why do most AI initiatives fail?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most enterprise AI initiatives stall at adoption, not at the technical layer. They fail where the human beings are: inside the judgment, trust, and change capacity of the people asked to use them. Without human capacity developed at scale, the failure rate stays high."
          }
        },
        {
          "@type": "Question",
          "name": "Who does ParadoxEdge work with?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "ParadoxEdge works with the leaders and companies deploying AI, from founder-led and small-to-mid-market teams to enterprise executive teams. Kent Frazier leads every engagement personally, with a trusted bench around him."
          }
        },
        {
          "@type": "Question",
          "name": "Who is Kent Frazier?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Kent H. Frazier is the founder of ParadoxEdge. He is a former enterprise HR and leadership executive with time inside Amazon Web Services (AWS) and other large technology organizations, a Certified Integral Master Coach, and the author of Love Fiercely: The Way of The Wood Dragon. Based in Denver, Colorado."
          }
        }
      ]
    }
  ];

  return (
    <>
      <SEOHead
        title="ParadoxEdge | The Human Side of AI Transformation | Executive Coaching"
        description="Executive coaching for the human side of AI transformation. We develop the human capacity (judgment, presence, trustworthiness) that determines whether AI investment lands."
        canonicalUrl="/"
        keywords="human side of AI transformation, AI transformation coaching, human capacity, executive coaching, leadership development, AI adoption, change leadership, Kent Frazier, Denver executive coach"
        jsonLd={homeJsonLd}
      />
      <div className="min-h-screen bg-background flex flex-col">
        <Navigation />
        <ElfsightWidget />
        <main className="flex-1">
          <HomeHeroSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
